// src/App.js
import React, { useState } from "react";
import PrimerComponente from "./components/PrimerComponente";
import CuartoComponente from "./components/CuartoComponente";
import PanelAdmin from "./components/PanelAdmin";
import { generarExcel } from "./utils/utilsExcel";
import DashboardUsuario from "./components/DashboardUsuario";

function App() {
  const [loginActivo, setLoginActivo] = useState(false);
  const [adminLogueado, setAdminLogueado] = useState(false);
  const [userLogueado, setUserLogueado] = useState(false);
  const [showAppointment, setShowAppointment] = useState(false);

  const handleLogout = () => {
    setAdminLogueado(false);
    setUserLogueado(false);
    setShowAppointment(false);
  };

  const exportarUsuarios = () => {
    const usuarios = JSON.parse(localStorage.getItem("usuarios")) || [];
    generarExcel("UsuariosRegistrados.xlsx", usuarios);
  };

  const exportarLogins = () => {
    const logins = JSON.parse(localStorage.getItem("logins")) || [];
    generarExcel("HistorialLogins.xlsx", logins);
  };

  // 1) Admin: solo PanelAdmin
  if (adminLogueado) {
    return (
      <div style={{ position: 'relative', minHeight: '100vh' }}>
        <PanelAdmin onLogout={handleLogout} />
      </div>
    );
  }

  // 2) Usuario normal: SOLO DashboardUsuario
  if (userLogueado) {
    return (
      <div style={{ position: 'relative', minHeight: '100vh' }}>
        <DashboardUsuario
          onLogout={handleLogout}
          onAgendar={() => setShowAppointment(true)}
        />

        {/* Modal de Agendamiento de Citas */}
        {showAppointment && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0,0,0,0.5)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 2000
            }}
            onClick={() => setShowAppointment(false)}
          >
            <div onClick={(e) => e.stopPropagation()}>
              <CuartoComponente
                showAppointment={true}
                onClose={() => setShowAppointment(false)}
                setUserLogueado={setUserLogueado}
              />
            </div>
          </div>
        )}
      </div>
    );
  }

  // 3) Retorna sin login
  return (
    <div style={{ position: 'relative', minHeight: '100vh' }}>
      <PrimerComponente
        adminLogueado={adminLogueado}
        exportarUsuarios={exportarUsuarios}
        exportarLogins={exportarLogins}
      />

      {/* Botón Login */}
      <button
        onClick={() => setLoginActivo(true)}
        style={{
          position: 'absolute',
          right: '20px',
          top: '20px',
          padding: '10px 20px',
          backgroundColor: '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
          zIndex: 100
        }}
      >
        Login
      </button>

      {/* Modal Login */}
      {loginActivo && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 2000
          }}
          onClick={() => setLoginActivo(false)}
        >
          <div onClick={(e) => e.stopPropagation()}>
            <CuartoComponente
              setAdminLogueado={setAdminLogueado}
              setUserLogueado={setUserLogueado}
              onClose={() => setLoginActivo(false)}
              showAppointmentButton={true}
              setShowAppointment={setShowAppointment}
            />
          </div>
        </div>
      )}

      {/* Modal de Agendamiento de Citas (se activa desde el botón en el login modal) */}
      {showAppointment && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 2000
          }}
          onClick={() => setShowAppointment(false)}
        >
          <div onClick={(e) => e.stopPropagation()}>
            <CuartoComponente
              showAppointment={true}
              onClose={() => setShowAppointment(false)}
              setUserLogueado={setUserLogueado}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default App;